import { PersoneelsdienstScheduler } from "@personeel/dialogs/PersoneelsdienstScheduler/PersoneelsdienstScheduler";
import { GenerateKlussen } from "@personeel/dialogs/GenerateKlussen/GenerateKlussen";
import React from "react";
import type { DienstOptie } from "../DienstOptie";
import "./KlussenOverviewHeader.css";

interface KlussenOverviewHeaderProps {
  readonly createKlus: () => void;
  readonly mogelijkeDiensten: DienstOptie[];
  readonly onAssignDienst: (dienst: DienstOptie) => void;
  readonly selectedCount: number;
}

export const KlussenOverviewHeader: React.FC<KlussenOverviewHeaderProps> = ({
  createKlus,
  mogelijkeDiensten,
  onAssignDienst,
  selectedCount,
}) => {
  const handleDienstClick = (dienst: DienstOptie) => {
    onAssignDienst(dienst);
  };

  return (
    <div className="klussen-overview-header" data-testid="header-klussen-overview">
      <div className="klussen-overview-header-top">
        <h1 className="klussen-overview-title">Klussen</h1>
        <div className="klussen-overview-buttons">
          {selectedCount > 0 && (
            <div className="klussen-overview-button-space toewijzen-container">
              <tractie-button
                level="secondary"
                id="dienstPopoverButton"
                data-testid="open-dienst-toewijzen-button"
              >
                <span>Geselecteerde klussen wijzigen </span>
                <tractie-icon name="chevron-down" />
              </tractie-button>
              <tractie-popover
                invoker-id="dienstPopoverButton"
                data-testid="popover-dienst-toewijzen"
              >
                {mogelijkeDiensten.length === 0 && (
                  <tractie-list-item
                    data-testid="option-dienst-geen-passend"
                    label="Geen passende dienst beschikbaar"
                  />
                )}
                {mogelijkeDiensten.length > 0 &&
                  mogelijkeDiensten.map((dienst) => (
                    <tractie-list-item
                      key={dienst.id}
                      data-testid={`option-dienst-${dienst.id}`}
                      label={dienst.label}
                      onClick={() => handleDienstClick(dienst)}
                    />
                  ))}
              </tractie-popover>
            </div>
          )}

          <div className="klussen-overview-button-space" data-testid="open-ps-scheduler-button">
            <PersoneelsdienstScheduler />
          </div>

          <div className="klussen-overview-button-space" data-testid="open-generate-klussen-button">
            <GenerateKlussen />
          </div>

          <tractie-button level="secondary" onClick={createKlus} data-testid="klus-aanmaken-button">
            <tractie-icon name="plus" />
            <span>Klus aanmaken</span>
          </tractie-button>
        </div>
      </div>
    </div>
  );
};
